import { useEmberMessagesStore } from '@/src/components/Ember/ember-messages.store'
import { resetEmberThread } from '@/src/hooks/useEmberThread.hook'
import create from 'zustand'

const DEFAULT_INITIAL_PROPOSED_QUESTIONS = ['Was war meine Grundlast im letzten Monat?', 'Visualisiere meinen Lastgang von vorgestern']

interface EmberStoreState {
  isSidebarShowing: boolean
  isSidebarExpanded: boolean
  insight: any
  proposedQuestions: string[]
  proposedUserAction: any | null
  currentTabValue: string
}

interface EmberStoreActions {
  toggleSidebar: () => void
  toggleExpandSidebar: () => void
  setInsight: (insight: any) => void
  unsetInsight: () => void
  closeSidebar: () => void
  openSidebar: () => void
  resetChat: (threadId: string) => void
  setProposedQuestions: (questions: string[]) => void
  clearProposedQuestions: () => void
  setProposedUserAction: (action: any | null) => void
  setCurrentTabValue: (tabValue: string) => void
}

interface EmberStore extends EmberStoreState, EmberStoreActions {}

export const useEmberStore = create<EmberStore>((set, get) => ({
  isSidebarShowing: false,
  isSidebarExpanded: false,
  insight: null,
  proposedQuestions: DEFAULT_INITIAL_PROPOSED_QUESTIONS,
  proposedUserAction: null,
  currentTabValue: 'chat',
  toggleSidebar: () =>
    set(state => {
      return { isSidebarShowing: !state.isSidebarShowing, isSidebarExpanded: false }
    }),
  closeSidebar: () => set(() => ({ isSidebarShowing: false, isSidebarExpanded: false })),
  openSidebar: () => set(() => ({ isSidebarShowing: true, isSidebarExpanded: false })),
  toggleExpandSidebar: () =>
    set(state => {
      return { isSidebarExpanded: !state.isSidebarExpanded }
    }),
  setInsight: insight => {
    set(() => {
      return { insight }
    })
  },
  unsetInsight: () => {
    set(() => {
      return { insight: null }
    })
  },
  resetChat: (threadId: string) => {
    // Clear messages from store
    useEmberMessagesStore.getState().clearMessages(threadId)

    // Reset thread ID
    resetEmberThread('chat')

    // Reset proposed questions to default
    set(() => ({ proposedQuestions: DEFAULT_INITIAL_PROPOSED_QUESTIONS }))

    // Reset proposed user action to null
    set(() => ({ proposedUserAction: null }))

    // Reset insight to null
    set(() => ({ insight: null }))
  },
  setProposedQuestions: (questions: string[]) => {
    set(() => ({ proposedQuestions: questions }))
  },
  clearProposedQuestions: () => {
    set(() => ({ proposedQuestions: [] }))
  },
  setProposedUserAction: (action: any | null) => {
    set(() => ({ proposedUserAction: action }))
  },
  setCurrentTabValue: (tabValue: string) => {
    set(() => ({ currentTabValue: tabValue }))
  },
}))
